import { Link } from 'react-router-dom';

export default function PaymentSuccess() {
  let payment = {};
  try {
    payment = JSON.parse(sessionStorage.getItem('lastSubscriptionPayment') || '{}');
  } catch (_error) {
    payment = {};
  }

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-3xl bg-white p-8 shadow-xl text-center">
        <div className="text-sm font-semibold uppercase tracking-[0.2em] text-emerald-600">Payment verified</div>
        <h1 className="mt-3 text-3xl font-bold text-slate-900">Your clinic workspace is ready</h1>
        <p className="mt-3 text-slate-600">Razorpay payment was verified by the backend before activation.</p>
        {payment.amountPaid ? (
          <div className="mt-5 rounded-2xl bg-emerald-50 p-4 text-sm text-emerald-800">
            Amount paid: ₹{Number(payment.amountPaid || 0).toLocaleString('en-IN')} {payment.currency || 'INR'}
          </div>
        ) : null}
        <Link to="/setup" className="mt-6 inline-flex rounded-2xl bg-indigo-600 px-5 py-3 font-semibold text-white">
          Continue to Setup Dektal 360
        </Link>
      </div>
    </div>
  );
}
